import { useMutation } from "@shared/lib/hooks";
import { ReportService } from "../../services/Report.servie";
import { ToastService } from "@shared/lib/services";

import { IReportCustomFieledConfig } from "@shared/lib/types/reports";
import { REPORTS_LIST_QUERY_KEY } from "../../constants";

interface IToggleReportDataFieldRequest {
  reportId: string;
  visibileCustomFieldsV2: IReportCustomFieledConfig[];
}

export function useToggleReportDataField(
  reportId: string,
  handleSuccess?: () => void
) {
  const {
    mutate: toggleDataField,
    isLoading: isToggling,
    isSuccess: isToggled,
  } = useMutation({
    mutationFn: (data: IToggleReportDataFieldRequest) =>
      ReportService.toggleReportDataFieldV2(
        data.reportId,
        data.visibileCustomFieldsV2
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c) => {
      handleSuccess?.();
      setTimeout(() => {
        c.invalidateQueries({
          queryKey: [REPORTS_LIST_QUERY_KEY, reportId],
          exact: false,
        });
      }, 1000);
    },
  });

  return {
    toggleDataField,
    isToggling,
    isToggled,
  };
}
